function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M30.999 61.999c-17.121 0-31-13.879-31-31 0-17.121 13.879-31 31-31 17.121 0 30.999 13.879 30.999 31 0 17.121-13.878 31-30.999 31zm0-60.121c-16.083 0-29.121 13.038-29.121 29.121S14.916 60.12 30.999 60.12 60.12 47.082 60.12 30.999 47.082 1.878 30.999 1.878zm3.355 42.311a1.011 1.011 0 0 1-.887.636h-.055c-.374 0-.719-.207-.893-.539l-4.801-9.07-9.093-4.79a1.01 1.01 0 0 1 .098-1.831l23.867-9.534a1.012 1.012 0 0 1 1.319 1.312l-9.555 23.816zM21.507 29.658l6.774 3.569 10.483-10.463-17.257 6.894zm8.201 4.997l3.58 6.767 6.906-17.227-10.486 10.46zm-8.95 1.434c.404.386.418 1.024.031 1.428l-3.087 3.01c-.19.183-.444.286-.708.285l.003.003a1.009 1.009 0 0 1-.709-1.733l3.088-3.01a1.012 1.012 0 0 1 1.382.017zm3.592 1.06v.004a1.015 1.015 0 0 1 1.38 0c.408.38.431 1.02.049 1.427l-6.393 6.377c-.015.017-.033.033-.049.05-.41.38-1.05.358-1.431-.05a1.01 1.01 0 0 1 .05-1.428l6.394-6.38zm1.226 5.094l.049-.046a1.013 1.013 0 0 1 1.43.064c.376.412.347 1.05-.065 1.426l-3.087 3.011a1.016 1.016 0 0 1-1.431 0l-.016-.017a1.007 1.007 0 0 1 .034-1.428l3.086-3.01z"
});

var SvgSend = function SvgSend(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSend, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/send.8ccd2d31.svg";
export { ForwardRef as ReactComponent };